/** Element UI 把数字 0 当空值，未选择用非空占位，提交时再转成 0 */
export const GOODS_UNSET_GID = "__unset__";

export function isUnsetGoodsGid(gid) {
  return (
    gid === GOODS_UNSET_GID ||
    gid === undefined ||
    gid === null ||
    gid === "" ||
    Number(gid) === 0
  );
}

export function toGoodsSelectValue(gid) {
  return isUnsetGoodsGid(gid) ? GOODS_UNSET_GID : gid;
}

export function toGoodsApiValue(gid) {
  return isUnsetGoodsGid(gid) ? 0 : gid;
}

export function goodsOptionLabel(item) {
  if (!item) return "";
  const title = item.title != null ? String(item.title) : "";
  if (item.id === undefined || item.id === null || item.id === "") {
    return title;
  }
  return title + " (ID: " + item.id + ")";
}

export function filterGoodsOptions(list, query) {
  const source = Array.isArray(list) ? list : [];
  const q = String(query == null ? "" : query).trim().toLowerCase();
  if (!q) return source;
  return source.filter(function (item) {
    if (!item) return false;
    const title = String(item.title || "").toLowerCase();
    const id = String(item.id == null ? "" : item.id).toLowerCase();
    return title.indexOf(q) !== -1 || id.indexOf(q) !== -1;
  });
}

export function normalizeGoodsName(name) {
  return String(name == null ? "" : name).trim();
}

export function findGoodsByTitle(list, name) {
  const needle = normalizeGoodsName(name);
  if (!needle || !Array.isArray(list)) return null;
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (item && normalizeGoodsName(item.title) === needle) {
      return item;
    }
  }
  return null;
}

function looksLikeGoodsId(value) {
  if (typeof value === "number" && Number.isFinite(value)) return true;
  if (typeof value === "string" && /^\d+$/.test(value.trim())) return true;
  return false;
}

export function resolveGoodsSelectValue(list, value) {
  if (value === undefined || value === null || value === "") return value;
  if (value === 0 || value === "0") return value;

  const goods = Array.isArray(list) ? list : [];

  if (looksLikeGoodsId(value)) {
    const byId = goods.find(function (item) {
      return item && String(item.id) === String(value).trim();
    });
    return byId ? byId.id : value;
  }

  const name = normalizeGoodsName(value);
  const byTitle = findGoodsByTitle(goods, name);
  return byTitle ? byTitle.id : name;
}

export function collectCreatedGoodsNames(hdList, goodsList) {
  const names = [];
  const seen = {};
  walkHdList(hdList, function (item) {
    const resolved = resolveGoodsSelectValue(goodsList, item && item.gid);
    if (resolved === 0 || resolved === "0" || resolved == null || resolved === "") {
      return;
    }
    if (looksLikeGoodsId(resolved) && findGoodsById(goodsList, resolved)) {
      return;
    }
    const name = normalizeGoodsName(resolved);
    if (!name || seen[name]) return;
    seen[name] = true;
    names.push(name);
  });
  return names;
}

export function applyResolvedGoodsIds(hdList, goodsList) {
  walkHdList(hdList, function (item) {
    if (!item) return;
    item.gid = resolveGoodsSelectValue(goodsList, item.gid);
  });
}

export function walkHdList(list, fn) {
  if (!Array.isArray(list)) return;
  list.forEach(function (item) {
    fn(item);
    if (item && item.children && item.children.length) {
      walkHdList(item.children, fn);
    }
  });
}

function findGoodsById(list, id) {
  if (!Array.isArray(list)) return null;
  return (
    list.find(function (item) {
      return item && String(item.id) === String(id);
    }) || null
  );
}
